var path = '/common/component/loader/tpl/loader.html';
var html = "<div class=thismoment-loader ng-class=\"{\n    'block' : $ctrl.displayBlock,\n    'row'   : !$ctrl.displayBlock\n}\"> <div class=thismoment-loader-container> <div class=loader ng-style=$ctrl.styles.loader></div> <div class=loader-message ng-bind=$ctrl.loadMessage></div> </div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/common/component/loader/tpl/loader.html
// module id = 260
// module chunks = 0 1 2 3 4